import { Typography } from '@mui/material';
import React from 'react';
import useWelcomeStyles from '../../styles/opt-in/welcome.style';
import { PiButton } from '@sensei/pi-component';
import { useTranslation } from 'react-i18next';

type Props = {
    buttonText: string;
    onButtonClick: () => void;
};

export function Welcome(props: Props) {
    const classes = useWelcomeStyles();
    const { t } = useTranslation();

    return (
        <div className={classes.root}>
            <Typography className={classes.title}>
                {t('optInWelcome.title')}
            </Typography>
            <ul>
                <li>
                    <Typography variant="body1">
                        {t('optInWelcome.upComingVisit')}
                    </Typography>
                </li>
                <li>
                    <Typography variant="body1">
                        {t('optInWelcome.safetyView')}
                    </Typography>
                </li>
                <li>
                    <Typography variant="body1">
                        {t('optInWelcome.connectWithGuide')}
                    </Typography>
                </li>
            </ul>
            <PiButton
                fullWidth
                color="primary"
                className={classes.button}
                onClick={props.onButtonClick}
            >
                {props.buttonText}
            </PiButton>
        </div>
    );
}
